import {
    PlatformStorage,
    PlatformStorageKeysEnum,
} from "@core/data/infrastructures/storage/storage.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import type { ObjectLike } from "@core/domain/types/object-like.type";
import { injectable } from "inversify";

@injectable()
export class InMemoryStorage implements PlatformStorage {
    private readonly cache = new Map<string, string>();

    get(key: PlatformStorageKeysEnum): Nullable<string> {
        return this.cache.get(key) ?? null;
    }

    getObject<T extends ObjectLike<T> = Record<string, unknown>>(
        key: PlatformStorageKeysEnum,
    ): Nullable<T> {
        const value = this.get(key);

        if (value === null) return value;

        try {
            return JSON.parse(value) as T;
        } catch (error: unknown) {
            if (error instanceof SyntaxError) {
                console.error(error.message);
            }
            return null;
        }
    }

    set(key: PlatformStorageKeysEnum, value: string): void {
        this.cache.set(key, value);
    }

    setObject(
        key: PlatformStorageKeysEnum,
        value: Record<string, unknown>,
    ): void {
        this.set(key, JSON.stringify(value));
    }

    remove(key: PlatformStorageKeysEnum): void {
        this.cache.delete(key);
    }
}
